import type { Agency } from './Agency'
import type { AgencyGroup } from './AgencyGroup'

export type AgencyNodeType = 'agency' | 'agency-group'

export interface AgencyNode extends Agency {
  $type: 'agency'
}
export interface AgencyGroupNode extends AgencyGroup {
  $type: 'agency-group'
}

export type AgencyStructureNode = AgencyNode | AgencyGroupNode

export function isAgencyGroupNode(
  item: AgencyStructureNode
): item is AgencyGroupNode {
  return item.$type === 'agency-group'
}

export function isAgencyNode(item: AgencyStructureNode): item is AgencyNode {
  return item.$type === 'agency'
}

export function getAgencyNodeType(agencyNode: AgencyNode): AgencyNodeType {
  if (isAgencyNode(agencyNode)) {
    return 'agency'
  }
  return 'agency-group'
}

export type AgencyStructureView =
  | 'agency-structure'
  | 'agency-groups'
  | 'agencies'
  | 'deactivated-agencies'
